var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inter-group"},_vm._l((_vm.groupList),function(item){return _c('van-cell',{key:item.id,attrs:{"title":item.name},on:{"click":function($event){return _vm.handleDetail(item.id)}}},[_c('van-icon',{staticClass:"reply-open",attrs:{"name":_vm.replyOpenImg}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }